import React from "react";
import { Popover, OverlayTrigger, Button as BootstrapButton, Panel } from "react-bootstrap";

import Toggle from "react-toggle";

import { Button, Icon, getPrettyNumber, Accordion } from "aible";
import Select from "react-select";

import AibleStep from "containers/CreateWizard/AibleStep";

import SelectDataset from "components/CreateWizard/Academic/SelectDataset";
import ProblematicPredictors from "components/CreateWizard/Academic/ProblematicPredictors";
import { ProblematicPredictorLabel, ProblematicPredictorBar } from "components/CreateWizard/Dataset/Correlation";

import RetargetOutcomeModal from "containers/UnifiedProject/SelectData/RetargetOutcomeModal";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo } from "@fortawesome/free-solid-svg-icons";

import { DATA_CHECKS } from "containers/Home/reducer";

import { LineInput } from "components/Inputs/LineInput";

import styles from "./style.module.css";

function handlePlurals(count, value = "", noPlural = false) {
  return value + (noPlural || count === 1 ? "" : "s");
}

const VALIDATION_MESSAGES = [
  {
    message: ["too many values", "It would be discarded."],
    type: "high cardinality field",
    action: "would be ignored"
  },
  {
    message: ["It would be discarded."],
    type: "column",
    action: "would be ignored"
  },
  {
    message: ["missing values", "(", ")"],
    type: "column",
    count: 0,
    action: "with missing values would be updated"
  },
  {
    message: ["too many values", "most informative values", "flagged and included in the modeling step"],
    type: "high cardinality field",
    action: "would be updated"
  }
];

function checkMessage(message, checkArr) {
  for (let i = 0; i < checkArr.length; i++) {
    if (!message.toLowerCase().includes(checkArr[i].toLowerCase())) {
      return false;
    }
  }
  return true;
}

function parseValidation(updatedColumns) {
  const retValidation = VALIDATION_MESSAGES.map((validation) => ({
    ...validation,
    value: []
  }));
  const extra = {
    type: "column",
    action: "would be updated for other reasons",
    value: []
  };
  updatedColumns.forEach((col) => {
    let found = false;
    const message = col.metadata && col.metadata.message ? col.metadata.message : col.message;

    for (let i = 0; i < retValidation.length; i++) {
      if (!found && checkMessage(message, retValidation[i].message)) {
        retValidation[i].value.push(message);
        found = true;
        if (retValidation) break;
      }
    }
    if (!found) {
      extra.value.push(message);
    }
  });
  if (retValidation.length < 1) {
    extra.action = "would be updated";
  }
  retValidation.push(extra);
  return retValidation.filter((elem) => elem.value.length);
}

export default class Forecast extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  checkIsProblematicPredictor(column) {
    const { problematicPredictors } = this.props;
    if (problematicPredictors) {
      for (let i = 0; i < problematicPredictors.length; i++) {
        if (problematicPredictors[i].label === column) {
          return column + " might also be a Problematic Predictor";
        }
      }
    }
    return undefined;
  }

  renderForecastSelect() {
    const {
      projectId,
      forecastMode,
      updateForecastMode,
      forecastTimeCol,
      updateForecastTimeCol,
      forecastOptions,

      forecastTime,
      updateForecastTime,
      forecastTimeOptions,
      forecastTimeUnit,
      updateForecastTimeUnit
    } = this.props;

    return (
      <React.Fragment>
        <div className={styles.forecastSelect}>
          <div className={styles.forecastQuestion}>{"Which field indicates time?"}</div>
          <Select
            placeholder="Select Time Field"
            options={forecastOptions}
            value={{ value: forecastTimeCol, label: forecastTimeCol }}
            onChange={(v) => {
              updateForecastTimeCol(v.value);
            }}
            isDisabled={!isNaN(projectId)}
          />
          {/* {forecastTimeCol !== undefined && (
          <React.Fragment>
            <div className={styles.forecastQuestion}>{"Which forecasting problem are you trying to solve?"}</div>
            <div className={styles.forecastOption} style={isNaN(projectId) ? {cursor: "default"} : undefined} onClick={() => isNaN(projectId) && (updateForecastMode("TIME_SERIES"))}>
              <input
                type="radio"
                checked={forecastMode === "TIME_SERIES"}
                style={{marginTop: "0px", marginRight: "15px"}}
              />
              {`I have a time series (${forecastTimeCol}).  I want to use past behavior to predict the next few time periods.`}
            </div>
            <div className={styles.forecastOption} style={isNaN(projectId) ? {cursor: "default"} : undefined}  onClick={() => isNaN(projectId) && (updateForecastMode("REGRESSION"))}>
              <input
                type="radio"
                checked={forecastMode === "REGRESSION"}
                style={{marginTop: "0px", marginRight: "15px"}}
              />
              {"I have several time series.  I want to use lagged values from some series to predict the one I really care about."}
            </div>
            {forecastMode === "REGRESSION" && <div className={styles.regressionInput}>
              <LineInput
                value={forecastTime}
                onChange={(v) => updateForecastTime(v)}
                isMediumBox
                inputStyle={{fontSize: "13px", maxWidth: "75px"}}
              />
              <div className={styles.forecastTimeUnit}>
                <Select
                  placeholder="Select Time Unit"
                  options={forecastTimeOptions}
                  value={{value: forecastTimeUnit, label: forecastTimeUnit}}
                  onChange={v => {
                    updateForecastTimeUnit(v.value)
                  }}
                  style={{marginTop: "6px"}}
                  menuPlacement={"top"}
                />
              </div>
            </div>}
          </React.Fragment>
        )} */}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const {
      id,
      projectId,
      isShow,
      selectedDataset,
      datasetView,
      updateSelection,
      isRetrain,
      isForecast,
      forecastMode,
      updateIsForecast,
      updateForecastMode
    } = this.props;

    const noDatasetOutcome =
      selectedDataset && selectedDataset.status && selectedDataset.status.indexOf("missing_target_variable") !== -1;
    const finishedIndexing =
      selectedDataset &&
      selectedDataset.status &&
      selectedDataset.status.indexOf("indexing") === -1 &&
      selectedDataset.status.indexOf("finishing_indexing") === -1 &&
      !selectedDataset.stack_id;
    const isError = selectedDataset && selectedDataset.errors && selectedDataset.errors.length > 0;
    const isDone = selectedDataset && (selectedDataset.rowCount !== -1 || (finishedIndexing && noDatasetOutcome));
    const isLoading = !isDone && !isError;

    return (
      <div className={styles.forecastWrapper}>
        <div
          className={styles.selectSubheader}
          style={{
            marginLeft: "0px",
            marginBottom: "10px",
            marginTop: "15px",
            display: "flex",
            alignItems: "center"
          }}
        >
          {"Would you like to forecast future behavior? "}
          <div id={"eToggle"} className={styles.tHolder} style={{ marginLeft: "8px" }}>
            <Toggle
              checked={isForecast === true}
              icons={false}
              onChange={(e) => updateIsForecast(!isForecast)}
              disabled={!isNaN(projectId)}
            />
            <span className={isForecast === true ? styles.yPos : styles.nPos}>
              {isForecast === true ? "Yes" : "No"}
            </span>
          </div>
        </div>
        {isForecast && this.renderForecastSelect()}
      </div>
    );
  }
}

class DatasetLoading extends React.PureComponent {
  render() {
    return (
      <div className={styles.datasetLoadingWrapper}>
        <div className={styles.datasetLoadingText}>{"Evaluating Data..."}</div>
        <LoadingIndicator style={{ marginTop: "15px" }} />
      </div>
    );
  }
}

export class ReviewDatasetColumn extends React.PureComponent {
  render() {
    const { className, header, minWidth, style, noGrow, isLarge, ...retProps } = this.props;
    const retStyle = {
      ...style
    };
    if (noGrow) {
      retStyle.flexGrow = 0;
      retStyle.flexShrink = 0;
    }
    if (isLarge) {
      retStyle.flexBasis = 400;
      retStyle.maxWidth = 500;
    }
    return (
      <div
        {...this.retProps}
        className={styles.reviewDatasetColumn + (className ? " " + className : "")}
        style={retStyle}
      >
        {header ? <div className={styles.reviewDatasetColumnHeader}>{header}</div> : ""}
        <React.Fragment>{this.props.children}</React.Fragment>
      </div>
    );
  }
}

export class ReviewDatasetHeader extends React.PureComponent {
  render() {
    const { className, error, header, icon, noGrow, style, children } = this.props;
    const retStyle = {
      ...style
    };
    if (noGrow) {
      retStyle.flexGrow = 0;
      retStyle.flexShrink = 0;
    }
    return (
      <div className={styles.datasetReviewHeader + (className ? " " + className : "")} style={retStyle}>
        {icon ? (
          icon
        ) : (
          <Icon
            type={error ? "times" : "check"}
            isRound
            background={error ? "red" : "green"}
            style={error ? { padding: "5px" } : undefined}
            size={24}
          />
        )}
        {children ? <React.Fragment>{children}</React.Fragment> : <span>{header}</span>}
      </div>
    );
  }
}

export class ReviewDatasetItem extends React.PureComponent {
  render() {
    const { className, error, text, overlayTitle, overlay, icon, noIcon, isExpand, ...retProps } = this.props;
    return (
      <div {...retProps} className={styles.datasetReviewContent + (className ? " " + className : "")}>
        <div className={styles.datasetReviewHeaderContent}>
          {noIcon ? (
            ""
          ) : icon ? (
            icon
          ) : (
            <Icon type={error ? "timesRed" : "checkGreen"} isRound style={{ flexShrink: 0 }} />
          )}
          <span
            className={styles.datasetReviewHeaderText}
            style={{
              margin: noIcon ? "0px" : undefined,
              width: isExpand ? "100%" : undefined
            }}
          >
            {text}
          </span>
          {overlay ? (
            <OverlayTrigger
              placement={"top"}
              trigger={["click"]}
              rootClose
              overlay={
                <Popover id="popover-positioned-top" title={overlayTitle}>
                  {overlay}
                </Popover>
              }
            >
              <FontAwesomeIcon icon={faInfo} className={styles.typeIcon} style={{ marginLeft: "6px" }} />
            </OverlayTrigger>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export class ExpansionItem extends React.Component {
  state = {
    show: false
  };

  render() {
    const { className, label, limit, children, ...retProps } = this.props;
    const { show } = this.state;
    const retlabel = label === undefined ? "View all columns" : label;
    const retLimit = isNaN(limit) ? 5 : limit;
    return (
      <div
        {...retProps}
        className={styles.expansionWrapper + " " + (show ? styles.show : "") + " " + (className ? className : "")}
      >
        <div className={styles.expansionBody + " " + (show ? styles.show : "")}>
          {React.Children.map(children, (child, i) => {
            if (show || i < retLimit) {
              return child;
            } else {
              return "";
            }
          })}
        </div>
        <div className={styles.expansionFooter + " " + (show ? styles.show : "")}>
          <a onClick={() => this.setState({ show: !show })}>{show ? "Hide" : retlabel}</a>
        </div>
      </div>
    );
  }
}
